import { render, staticRenderFns } from "./ServiceResolved.vue?vue&type=template&id=3091fea2"
import script from "./ServiceResolved.vue?vue&type=script&lang=js"
export * from "./ServiceResolved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports